export function FeatureDraftIllustration({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 320 180" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect width="320" height="180" fill="#faf9f6" />
      
      <g transform="translate(50 40)">
        {/* Depth cues matching EmailAgent */}
        <rect x="-6" y="-6" width="220" height="130" rx="6" fill="none" stroke="#111111" strokeWidth="1.5" opacity="0.2" />
        <rect x="-3" y="-3" width="220" height="130" rx="6" fill="#faf9f6" stroke="#111111" strokeWidth="1.5" opacity="0.6" />
        
        <rect width="220" height="130" rx="6" fill="#ffffff" stroke="#111111" strokeWidth="1.5" />
        
        {/* Title bar */}
        <path d="M 0 24 L 220 24" stroke="#111111" strokeWidth="1.5" />
        <circle cx="12" cy="12" r="3" fill="#111111" />
        <circle cx="22" cy="12" r="3" fill="#111111" opacity="0.5" />
        
        {/* Skeleton lines for text */}
        <g transform="translate(16 40)">
          <rect y="0" width="160" height="6" rx="2" fill="#111111" opacity="0.8" />
          <rect y="12" width="180" height="6" rx="2" fill="#111111" opacity="0.4" />
          <rect y="24" width="120" height="6" rx="2" fill="#111111" opacity="0.4" />
          
          {/* AI generated text highlighted in Fin Orange */}
          <rect y="44" width="150" height="6" rx="2" fill="#ff5600" opacity="0.8" />
          <rect y="56" width="100" height="6" rx="2" fill="#ff5600" opacity="0.8" />
        </g>
        
        {/* AI sparkle cursor over the text */}
        <g transform="translate(130 90)">
          <circle cx="0" cy="0" r="12" fill="#ff5600" />
          <path d="M0 -5 L0 5 M-5 0 L5 0" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" />
        </g>
      </g>
    </svg>
  );
}
